import { clsx } from "clsx";
import type { SVGProps } from "react";
const SvgHandBagNotIncluded = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const mergedClassName = clsx("rtl:-scale-x-100", className);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      aria-hidden="true"
      className={mergedClassName}
      {...props}
    >
      <defs>
        <linearGradient
          id="handBagNotIncluded_svg__b"
          x1={21.849}
          x2={21.849}
          y1={6.567}
          y2={11.61}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#414141" stopOpacity={0.5} />
          <stop offset={1} stopColor="#6E6E6E" />
        </linearGradient>
        <linearGradient
          id="handBagNotIncluded_svg__d"
          x1={10.345}
          x2={10.345}
          y1={6.567}
          y2={11.61}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#414141" stopOpacity={0.5} />
          <stop offset={1} stopColor="#6E6E6E" />
        </linearGradient>
        <linearGradient
          id="handBagNotIncluded_svg__f"
          x1={16.082}
          x2={16.082}
          y1={11.283}
          y2={26.377}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ACACAC" stopOpacity={0.75} />
          <stop offset={1} stopColor="#A9A9A9" />
        </linearGradient>
        <clipPath
          id="handBagNotIncluded_svg__c"
          transform="translate(-6.147 -4.118)"
        >
          <path d="M11.217 11.454h2.325c0-3.553-2.698-6.336-4.36-6.336-1.21 0-2.035.982-2.035.982.96 0 4.07 3.045 4.07 5.354" />
        </clipPath>
        <clipPath
          id="handBagNotIncluded_svg__e"
          transform="translate(-6.942 -5.945)"
        >
          <path d="M24.223 25.909H7.943V13.68c0-3.72 3.044-6.736 6.799-6.736h2.681c3.755 0 6.8 3.016 6.8 6.736v12.23Z" />
        </clipPath>
        <filter
          id="handBagNotIncluded_svg__a"
          width={19.335}
          height={3.808}
          x={6.388}
          y={26.309}
          filterUnits="userSpaceOnUse"
        >
          <feGaussianBlur stdDeviation={0.75} />
        </filter>
      </defs>
      <g filter="url(#handBagNotIncluded_svg__a)" opacity={0.8}>
        <ellipse cx={16.055} cy={28.213} fill="#000" rx={8.168} ry={0.404} />
      </g>
      <g clipPath="url(#handBagNotIncluded_svg__b)">
        <path
          fill="#787878"
          d="M7.942 25.91a2.315 2.315 0 0 0 2.326 2.303h11.628a2.315 2.315 0 0 0 2.325-2.304v-1.08H7.942v1.08Z"
        />
        <path
          fill="#7B7B7B"
          d="M21.883 11.719s1.674-3.062 1.104-4.543l1.141-1.073h.916c.852 2.648-1.482 7.344-1.482 7.344z"
        />
        <path
          fill="url(#handBagNotIncluded_svg__b)"
          d="M20.977 11.454H18.65c0-3.553 2.699-6.336 4.36-6.336 1.211 0 2.036.982 2.036.982-.96 0-4.07 3.045-4.07 5.354Z"
        />
        <path
          fill="#7B7B7B"
          d="M10.306 11.719S8.633 8.657 9.204 7.176L8.06 6.103h-.916c-.852 2.648 1.482 7.343 1.482 7.343z"
        />
        <foreignObject width={8.396} height={8.336} x={6.147} y={4.118}>
          <div
            style={{
              backdropFilter: "blur(.5px)",
              clipPath: "url(#handBagNotIncluded_svg__c)",
              height: "100%",
              width: "100%",
            }}
          />
        </foreignObject>
        <path
          fill="url(#handBagNotIncluded_svg__d)"
          d="M11.217 11.454h2.325c0-3.553-2.698-6.336-4.36-6.336-1.21 0-2.035.982-2.035.982.961 0 4.07 3.045 4.07 5.354"
        />
        <path
          fill="#787878"
          d="M8.822 25.106H7.207a1.287 1.287 0 0 1-1.293-1.28v-4.927c0-.708.579-1.281 1.293-1.281h1.614zm14.533 0h1.614c.714 0 1.293-.573 1.293-1.28v-4.927c0-.708-.579-1.281-1.293-1.281h-1.614z"
        />
        <foreignObject width={18.28} height={20.963} x={6.942} y={5.945}>
          <div
            style={{
              backdropFilter: "blur(.5px)",
              clipPath: "url(#handBagNotIncluded_svg__e)",
              height: "100%",
              width: "100%",
            }}
          />
        </foreignObject>
        <path
          fill="url(#handBagNotIncluded_svg__f)"
          d="M24.223 25.909H7.943V13.68c0-3.72 3.044-6.736 6.799-6.736h2.681c3.755 0 6.8 3.016 6.8 6.736v12.23Z"
        />
        <path
          fill="#fff"
          d="m18.499 12.92-1.878-1.86a.89.89 0 0 0-1.251 0l-1.878 1.86a.87.87 0 0 0 0 1.24l1.878 1.86a.89.89 0 0 0 1.251 0l1.878-1.86a.87.87 0 0 0 0-1.24m-3 1.495a.415.415 0 0 1-.417.414.415.415 0 0 1-.417-.414v-1.751c0-.229.187-.414.417-.414.231 0 .417.185.417.414zm1.789 0a.415.415 0 0 1-.417.414.415.415 0 0 1-.417-.414v-1.751c0-.229.186-.414.417-.414s.417.185.417.414z"
        />
        <path
          fill="#D6D6D6"
          d="M10.678 20.125a2 2 0 0 1 2-2h6.537a2 2 0 0 1 2 2v3.599a.5.5 0 0 1-.5.5h-9.537a.5.5 0 0 1-.5-.5v-3.6Z"
        />
        <path
          fill="#787878"
          d="M20.715 23.923v.3h-9.537v-.3zm.2-.2v-3.598a1.7 1.7 0 0 0-1.7-1.7h-6.537a1.7 1.7 0 0 0-1.7 1.7v3.598c0 .11.09.2.2.2v.3a.5.5 0 0 1-.5-.5v-3.598a2 2 0 0 1 1.796-1.99l.204-.01h6.537a2 2 0 0 1 2 2v3.598a.5.5 0 0 1-.5.5v-.3a.2.2 0 0 0 .2-.2"
          opacity={0.7}
        />
        <path
          fill="#D4D4D4"
          d="M23.353 16.776h-.581V13.86c0-3.017-2.478-5.472-5.524-5.472h-2.325c-3.046 0-5.524 2.455-5.524 5.472v2.916h-.582V13.86c0-3.335 2.739-6.048 6.106-6.048h2.325c3.366 0 6.105 2.713 6.105 6.048z"
          opacity={0.5}
        />
      </g>
      <rect
        width={4.6}
        height={29.85}
        x={24.5}
        y={5.8}
        fill="#fff"
        rx={2.3}
        transform="rotate(45 24.5 5.8)"
      />
      <rect
        width={2}
        height={29.85}
        x={26.57}
        y={7.4}
        fill="#DE370C"
        rx={1}
        transform="rotate(45 26.57 7.4)"
      />
    </svg>
  );
};
export default SvgHandBagNotIncluded;
